"use strict";

exports.__esModule = true;
exports.ComponentRemainingLifeValue = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ComponentRemainingLifeValue = exports.ComponentRemainingLifeValue = function ComponentRemainingLifeValue(props) {
  var width = props.width,
    totalHeight = props.totalHeight,
    fontSize = props.fontSize,
    value = props.value,
    label = props.label,
    dataTestId = props.dataTestId,
    eachComponentHeightDivision = props.eachComponentHeightDivision;
  var height = totalHeight / eachComponentHeightDivision;
  var yForValue = height / (eachComponentHeightDivision + 1);
  var yForLabel = yForValue + (fontSize || 15);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: 0,
      padding: 0,
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height
  }, /*#__PURE__*/_react["default"].createElement("text", {
    x: width / 2,
    y: yForValue,
    alignmentBaseline: "hanging",
    textAnchor: "middle",
    fontSize: fontSize,
    fontWeight: 600,
    "data-testid": dataTestId
  }, value), /*#__PURE__*/_react["default"].createElement("text", {
    x: width / 2,
    y: yForLabel,
    textAnchor: "middle",
    alignmentBaseline: "hanging",
    fontSize: 12
  }, label)));
};